// removed by extract-text-webpack-plugin
module.exports = {"instructions-container":"UpcomingInstructions__instructions-container___3Oc7P"};